<div class="mb-3 flex items-center gap-4" [formGroup]="formSearch">
  <mat-form-field
    class="input-tg search-tg mt-message-input w-2/5"
    appearance="outline"
  >
    <mat-label>Pesquisa</mat-label>
    <input matInput formControlName="search" />
  </mat-form-field>
  <!--  <div>-->
  <!--    <button-->
  <!--      class="btn-icon"-->
  <!--      (click)="sendSearch()"-->
  <!--      [disabled]="!checkForm()"-->
  <!--      [ngClass]="checkForm() ? '' : 'disabled'"-->
  <!--      [matTooltip]="checkSearch() ? 'Pesquisa' : 'Limpar Pesquisar'"-->
  <!--    >-->
  <!--      @if (checkSearch()) {-->
  <!--        <mat-icon>search</mat-icon>-->
  <!--      } @else {-->
  <!--        <mat-icon>replay</mat-icon>-->
  <!--      }-->
  <!--    </button>-->
  <!--  </div>-->
  <div class="flex gap-2">
    <button
      class="btn-icon"
      (click)="clearSearch()"
      [matTooltip]="'Limpar Pesquisar'"
    >
      <mat-icon>replay</mat-icon>
    </button>
    <button
      class="btn-icon"
      (click)="sendSearch()"
      [disabled]="this.formSearch.get('search')?.value == ''"
      [ngClass]="this.formSearch.get('search')?.value != '' ? '' : 'disabled'"
      [matTooltip]="'Pesquisa'"
    >
      <mat-icon>search</mat-icon>
    </button>
  </div>
</div>
